import styled from 'styled-components';
import Lab114 from 'dc/Lab114';

export const DaysLeft = styled(Lab114)`
  flex-grow: 1;
`;
